module.exports = __webpack_public_path__ + "static/media/data-confirmation.91d2139c.svg";